import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getSurveyResult } from 'services/engagement';

export const useGetEngagementSurveyResults = (surveyId: string) =>
  useQuery([REACT_QUERY_KEYS.engagementSurveyResults, surveyId], () => getSurveyResult({ surveyId }), {
    enabled: !!surveyId,
  });
